import { Schema } from "rsuite";

const { Model, Types } = Schema;

export type ChangePasswordFormType = {
  CurrentPassword?: string;
  NewPassword?: string;
  confPassword?: string;
};

export const ChangePasswordFormSchema = Model({
  CurrentPassword: Types.StringType().isRequired("Old Password is required"),
  NewPassword: Types.StringType().isRequired("New Password is required"),
  confPassword: Types.StringType().isRequired("Confirm Password is required"),
});

export const ChangePasswordDefaultValues: ChangePasswordFormType = {
  CurrentPassword: "",
  NewPassword: "",
  confPassword: "",
};
